<template>
    <div class="home-page">
        <div class="page-container">
            <page-header></page-header>
            <page-nav></page-nav>
			<div class="page-content">
				<router-view></router-view>
			</div>
        </div>
    </div>  
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PageNav from '@/components/PageNav'

export default {
    components: {
		PageHeader,
		PageNav,
	},
}
</script>

<style scoped>
.page-container {
	display: flex;
	height: 100vh;
	flex-direction: column;
}
.page-content {
	flex: 1;
}
</style>


